import React from 'react';
import {
  Button,
  Modal,
  ModalSection,
  ModalHeader,
  ModalFooter,
  Gutter,
} from '@axiom/ui';
import type { Candidate, Experience } from '@axiom/validation';

import { CandidateUtil } from '../../utils/candidate-util';

export type ExperienceEditDescriptionLengthWarningModalType = {
  candidate: Candidate;
  experience: Experience;
  name: string;
  onClose: () => void;
  onContinue: () => void | Promise<void>;
  onRequestException: () => void | Promise<void>;
};

export const ExperienceEditDescriptionLengthWarningModal = ({
  candidate,
  experience,
  name,
  onClose,
  onContinue,
  onRequestException,
}: ExperienceEditDescriptionLengthWarningModalType) => {
  const talentPartner = CandidateUtil.getTalentPartnerUser(candidate);
  return (
    <Modal name={name}>
      <ModalHeader
        name="EXPERIENCE_EDIT_DESCRIPTION_LENGTH_WARNING_MODAL_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        This description is too short
      </ModalHeader>
      <ModalSection name="EXPERIENCE_EDIT_DESCRIPTION_LENGTH_WARNING_MODAL_SECTION">
        Your description needs {experience.expectedDescriptionLength}+
        characters to help clients understand your expertise. Here’s what you
        can do:
        <Gutter bottom="16px" />
        <ul>
          <li>Go back and add more details (recommended).</li>
          <li>
            Continue and edit the description later. This will not clear the
            action needed alert in your profile.
          </li>
          <li>
            Request an exception. Contact your Axiom talent partner (
            {talentPartner.firstName} {talentPartner.lastName}) if you’ve tried
            but really can't reach {experience.expectedDescriptionLength}{' '}
            characters.
          </li>
        </ul>
      </ModalSection>
      <ModalFooter stackableOn="mobile">
        <Button
          name="EXPERIENCE_EDIT_DESCRIPTION_LENGTH_WARNING_MODAL_REQUEST_EXCEPTION"
          variation="outline"
          onClick={async () => {
            await onRequestException();
          }}
        >
          Request exception
        </Button>
        <Button
          name="EXPERIENCE_EDIT_DESCRIPTION_LENGTH_WARNING_MODAL_CONTINUE"
          variation="outline"
          onClick={async () => {
            await onContinue();
          }}
        >
          Continue and edit later
        </Button>
        <Button
          name="EXPERIENCE_EDIT_DESCRIPTION_LENGTH_WARNING_MODAL_CANCEL"
          onClick={() => {
            onClose();
          }}
        >
          Go Back
        </Button>
      </ModalFooter>
    </Modal>
  );
};
